export default {
  tipoPlanilha: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  fileDetails: {
    value: null,
    required: false,
    state: null
  },
  tipoBoardCobrancaEmprestimo: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaEmprestimo: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardCobrancaCartao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaCartao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardCobrancaGerais: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaGerais: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardParcelasEmAberto: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardAjuizamento: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaAjuizamento: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  origemImportCards: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  boardImportCards: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  columnImportCards: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  vincularGerenteAoCard: {
    value: false,
    defaultValue: false,
    state: null
  },
  vincularGerenteRelacionamento: {
    value: false,
    defaultValue: false,
    state: null
  },
  atualizarClusterizacao: {
    value: false,
    defaultValue: false,
    state: null
  },
  atualizarResponsaveis: {
    value: false,
    defaultValue: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/import/components/add/import-form.js